// @generated by protoc-gen-es v2.9.0 with parameter "import_extension=js"
// @generated from file services/ontology/resources/pipeline_event.proto (package gx.ontology.resources, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_struct } from "@bufbuild/protobuf/wkt";

/**
 * Describes the file services/ontology/resources/pipeline_event.proto.
 */
export const file_services_ontology_resources_pipeline_event = /*@__PURE__*/
  fileDesc("CjBzZXJ2aWNlcy9vbnRvbG9neS9yZXNvdXJjZXMvcGlwZWxpbmVfZXZlbnQucHJvdG8SFWd4Lm9udG9sb2d5LnJlc291cmNlcyJkCh1QaXBlbGluZUV2ZW50VG9vbENhbGxNZXRhZGF0YRIRCgl0b29sX25hbWUYASABKAkSMAoPdG9vbF9wYXJhbWV0ZXJzGAIgASgLMhcuZ29vZ2xlLnByb3RvYnVmLlN0cnVjdCJiCh9QaXBlbGluZUV2ZW50VG9vbFJlc3VsdE1ldGFkYXRhEhEKCXRvb2xfbmFtZRgBIAEoCRIsCgt0b29sX3Jlc3VsdBgCIAEoCzIXLmdvb2dsZS5wcm90b2J1Zi5TdHJ1Y3QiMAodUGlwZWxpbmVFdmVudFRoaW5raW5nTWV0YWRhdGESDwoHY29udGVudBgBIAEoCSKEAgoVUGlwZWxpbmVFdmVudE1ldGFkYXRhEkkKCXRvb2xfY2FsbBgBIAEoCzI0Lmd4Lm9udG9sb2d5LnJlc291cmNlcy5QaXBlbGluZUV2ZW50VG9vbENhbGxNZXRhZGF0YUgAEk0KC3Rvb2xfcmVzdWx0GAIgASgLMjYuZ3gub250b2xvZ3kucmVzb3VyY2VzLlBpcGVsaW5lRXZlbnRUb29sUmVzdWx0TWV0YWRhdGFIABJICgh0aGlua2luZxgDIAEoCzI0Lmd4Lm9udG9sb2d5LnJlc291cmNlcy5QaXBlbGluZUV2ZW50VGhpbmtpbmdNZXRhZGF0YUgAQgcKBXZhbHVlKskBChNQaXBlbGluZUV2ZW50U3RhdHVzEiUKIVBJUEVMSU5FX0VWRU5UX1NUQVRVU19VTlNQRUNJRklFRBAAEiEKHVBJUEVMSU5FX0VWRU5UX1NUQVRVU19QRU5ESU5HEAESIQodUElQRUxJTkVfRVZFTlRfU1RBVFVTX1JVTk5JTkcQAhIjCh9QSVBFTElORV9FVkVOVF9TVEFUVVNfQ09NUExFVEVEEAMSIAocUElQRUxJTkVfRVZFTlRfU1RBVFVTX0ZBSUxFRBAEKuYBChFQaXBlbGluZUV2ZW50VHlwZRIjCh9QSVBFTElORV9FVkVOVF9UWVBFX1VOU1BFQ0lGSUVEEAASJQohUElQRUxJTkVfRVZFTlRfVFlQRV9TVEFUVVNfQ0hBTkdFEAESIAocUElQRUxJTkVfRVZFTlRfVFlQRV9USElOS0lORxACEiEKHVBJUEVMSU5FX0VWRU5UX1RZUEVfVE9PTF9DQUxMEAMSIwofUElQRUxJTkVfRVZFTlRfVFlQRV9UT09MX1JFU1VMVBAEEhsKF1BJUEVMSU5FX0VWRU5UX1RZUEVfTE9HEAVC7gEKGWNvbS5neC5vbnRvbG9neS5yZXNvdXJjZXNCElBpcGVsaW5lRXZlbnRQcm90b1ABWkdnaXRodWIuY29tL2dhbGF4eS1pby9neC9zaGFyZWQvZ28vY29udHJhY3RzL3NlcnZpY2VzL29udG9sb2d5L3Jlc291cmNlc6ICA0dPUqoCFUd4Lk9udG9sb2d5LlJlc291cmNlc8oCFUd4XE9udG9sb2d5XFJlc291cmNlc+ICIUd4XE9udG9sb2d5XFJlc291cmNlc1xHUEJNZXRhZGF0YeoCF0d4OjpPbnRvbG9neTo6UmVzb3VyY2VzYgZwcm90bzM", [file_google_protobuf_struct]);

/**
 * Describes the message gx.ontology.resources.PipelineEventToolCallMetadata.
 * Use `create(PipelineEventToolCallMetadataSchema)` to create a new message.
 */
export const PipelineEventToolCallMetadataSchema = /*@__PURE__*/
  messageDesc(file_services_ontology_resources_pipeline_event, 0);

/**
 * Describes the message gx.ontology.resources.PipelineEventToolResultMetadata.
 * Use `create(PipelineEventToolResultMetadataSchema)` to create a new message.
 */
export const PipelineEventToolResultMetadataSchema = /*@__PURE__*/
  messageDesc(file_services_ontology_resources_pipeline_event, 1);

/**
 * Describes the message gx.ontology.resources.PipelineEventThinkingMetadata.
 * Use `create(PipelineEventThinkingMetadataSchema)` to create a new message.
 */
export const PipelineEventThinkingMetadataSchema = /*@__PURE__*/
  messageDesc(file_services_ontology_resources_pipeline_event, 2);

/**
 * Describes the message gx.ontology.resources.PipelineEventMetadata.
 * Use `create(PipelineEventMetadataSchema)` to create a new message.
 */
export const PipelineEventMetadataSchema = /*@__PURE__*/
  messageDesc(file_services_ontology_resources_pipeline_event, 3);

/**
 * Describes the enum gx.ontology.resources.PipelineEventStatus.
 */
export const PipelineEventStatusSchema = /*@__PURE__*/
  enumDesc(file_services_ontology_resources_pipeline_event, 0);

/**
 * @generated from enum gx.ontology.resources.PipelineEventStatus
 */
export const PipelineEventStatus = /*@__PURE__*/
  tsEnum(PipelineEventStatusSchema);

/**
 * Describes the enum gx.ontology.resources.PipelineEventType.
 */
export const PipelineEventTypeSchema = /*@__PURE__*/
  enumDesc(file_services_ontology_resources_pipeline_event, 1);

/**
 * @generated from enum gx.ontology.resources.PipelineEventType
 */
export const PipelineEventType = /*@__PURE__*/
  tsEnum(PipelineEventTypeSchema);

